module.exports = __webpack_public_path__ + "static/img/logo6-2.96270c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo6-2.png
// module id = E3yN
// module chunks = 1